import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { blockActions, getBlocks } from "data/blockApi"

class WithBlocks extends React.Component {
    render() {
        const blocksData = this.props.blocks
        if (!blocksData) return this.props.loading ? this.props.loading : ""
        const blocks = Object.values(blocksData)
        return this.props.children({
            blocks,
            onChange: this.props.blockActions.update,
            createBlock: this.props.blockActions.create,
        })
    }

    constructor(props) {
        super(props)
        props.blockActions.fetch()
    }
}

WithBlocks.propTypes = {}

function mapStateToProps(state) {
    return {
        blocks: getBlocks(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        blockActions: bindActionCreators(blockActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithBlocks)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithBlocks.js